export default "__VITE_ASSET__aa244c82__"